import { formatCOP, formatDate } from '@/lib/format';
import type { AmortizationRow } from '@shared/types';

/**
 * Mes / Fecha / Saldo inicial / Cuota / Interés / Capital / Saldo final.
 * Resalta el mes en que el capital pagado supera al interés — el "punto
 * de quiebre" de un crédito, motivador de ver en la propia tabla.
 */
export function AmortizationTable({ schedule }: { schedule: AmortizationRow[] }) {
  const breakEvenMonth = schedule.find((row) => row.principal > row.interest)?.month;

  return (
    <div className="max-h-[28rem] overflow-auto rounded-lg border border-border">
      <table className="w-full min-w-[640px] text-sm">
        <thead className="sticky top-0 bg-card text-xs text-muted-foreground">
          <tr>
            <th className="px-3 py-2 text-left font-medium">Mes</th>
            <th className="px-3 py-2 text-left font-medium">Fecha</th>
            <th className="px-3 py-2 text-right font-medium">Saldo inicial</th>
            <th className="px-3 py-2 text-right font-medium">Cuota</th>
            <th className="px-3 py-2 text-right font-medium">Interés</th>
            <th className="px-3 py-2 text-right font-medium">Capital</th>
            <th className="px-3 py-2 text-right font-medium">Saldo final</th>
          </tr>
        </thead>
        <tbody>
          {schedule.map((row) => (
            <tr
              key={row.month}
              className={row.month === breakEvenMonth ? 'bg-income/10' : 'odd:bg-muted/30'}
              title={row.month === breakEvenMonth ? 'Punto de quiebre: el capital ya supera al interés' : undefined}
            >
              <td className="px-3 py-1.5">{row.month}</td>
              <td className="px-3 py-1.5">{formatDate(row.date)}</td>
              <td className="px-3 py-1.5 text-right tabular-nums">{formatCOP(row.openingBalance)}</td>
              <td className="px-3 py-1.5 text-right tabular-nums">{formatCOP(row.payment)}</td>
              <td className="px-3 py-1.5 text-right tabular-nums text-debt">{formatCOP(row.interest)}</td>
              <td className="px-3 py-1.5 text-right tabular-nums text-income">{formatCOP(row.principal)}</td>
              <td className="px-3 py-1.5 text-right tabular-nums">{formatCOP(row.closingBalance)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
